






















































import Vue from 'vue';
import VueCompositionAPI, {defineComponent, computed} from '@vue/composition-api';
// @ts-ignore
import Airplane from '../svg/departure.vue';
import {Activity, CandidateTransportationItem, lang} from '@mobi-components/global-solution';
import {startOfDay} from '@mobi-components/global-date-time-picker';
import {Tag} from '@mobi-components/amex-bluesky-components';
import {getFlightPrice} from './main-flight-card/useFlightPrices';
import {isActivityBooked} from '@/store/state/helpers';
import {getUserId} from '@/services/auth-shared';
import {trackBtnClick} from '@/store/api/trackBtnClick';
import {openDynamicUrl} from '../summary-page/useSaveSolutionDialod';

Vue.use(VueCompositionAPI);

interface PropTypes {
  flight: Activity;
}

export function formatBudget(value: number | string, currency = 'USD', suffix = '', maximumFractionDigits = 0) {
  let defaultValue = '';
  if (!value) {
    return defaultValue;
  }
  let formatter = new Intl.NumberFormat(lang(), {maximumFractionDigits});
  try {
    const options =
      currency === 'AMEX_POINT' ? {maximumFractionDigits} : {style: 'currency', currency, maximumFractionDigits};
    formatter = new Intl.NumberFormat(lang(), options);
  } catch {
    //
  }
  const v = parseFloat(value.toString());
  defaultValue = formatter.format(v);
  return `${defaultValue} ${currency === 'AMEX_POINT' && defaultValue ? suffix : ''}`.trim();
}

const AmxStaticFlightDetailsCard = defineComponent({
  components: {
    Airplane,
    Tag,
  },
  props: {
    flight: Object,
  },
  setup(props: PropTypes, {emit}) {
    const flightImg = computed(() => {
      return props.flight?.images?.medium || '';
    });
    const price = computed(() => {
      return getFlightPrice(props.flight);
    });
    const details = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      return (flight?.name || '')
        .split(' ')
        .filter((_, i) => i === 0)
        .join('');
    });
    const duration = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }
      const hours = Math.floor(flight.duration / 3600);
      const minutes = Math.floor((flight.duration % 3600) / 60);
      const fixedMinutes = minutes.toString().length > 1 ? `${minutes.toString()}m` : `0${minutes.toString()}m`;
      const fixedHours = hours > 0 ? `${hours}h ` : '';
      return `${fixedHours}${fixedMinutes}`;
    });
    const direction = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }
      const content = flight.source?.content as CandidateTransportationItem;
      const origin = (content?.origin?.name || '').replace(/_/g, ', ');
      const destination = (content?.destination?.name || '').replace(/_/g, ', ');
      return origin && destination ? `${origin}-${destination}` : '';
    });
    const numberOfStops = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }
      const content = flight.source?.content as CandidateTransportationItem;
      const segments = (content?.transportation?.segments?.length || 1) - 1;
      let result = '';
      if (!segments) {
        return 'Non-stop';
      }
      if (segments > 0) {
        result = `${segments} Stop`;
      }
      if (segments > 1) {
        result = `${result}s`;
      }
      return result;
    });
    const stopNames = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }
      const content = flight.source?.content as CandidateTransportationItem;
      const segments = content?.transportation?.segments || [];
      return (
        segments
          .map((x) => x.destination)
          .slice(0, -1)
          .join(', ') || 'Non-stop'
      );
    });
    const airline = computed<string>(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }

      return (
        (flight?.types || [])
          .concat(flight?.source?.content?.tags || [])
          .slice(0, 2)
          .join(', ') || ''
      );
    });

    // TODO: Rewrite/Refactor to DateFormatter
    const dates = computed(() => {
      const flight = (props as PropTypes).flight;
      if (!flight) {
        return '';
      }
      const departureTime = new Date(flight.scheduled_start_time * 1000);
      const arrivalTime = new Date(flight.scheduled_end_time * 1000);
      const departureLocalTime = departureTime.toLocaleTimeString(lang(), {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
      const arrivalLocalTime = arrivalTime.toLocaleTimeString(lang(), {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
      const departureDate = startOfDay(departureTime);
      const arrivalDate = startOfDay(arrivalTime);
      // const dateDiff = arrivalDate.valueOf() - departureDate.valueOf();
      const departureLocalDate = departureDate.toLocaleDateString(lang(), {month: 'short', day: 'numeric'});
      const arrivalLocalDate = arrivalDate.toLocaleDateString(lang(), {month: 'short', day: 'numeric'});
      // const diff = dateDiff > 0 ? `+${Math.floor(dateDiff / 24 / 3600 / 1000)}` : '';
      return {
        departure: `${departureLocalDate}, ${departureLocalTime}`,
        arrival: `${arrivalLocalDate}, ${arrivalLocalTime}`,
      };
    });

    const bookingUrl = props.flight.source.content?.booking_url || '';

    const trackDetailsClick = (url: string) => {
      const userId = getUserId();
      trackBtnClick(userId, url);
    };
    const redirectToActivity = (activity: Activity, e: Event) => {
      trackDetailsClick(bookingUrl);
      e.preventDefault();
      e.stopPropagation();
      openDynamicUrl(bookingUrl);
      return false;
    };

    const bookActivity = (e: Event, status: boolean) => {
      e.preventDefault();
      emit('book', status);
    };

    const booked = computed(() => isActivityBooked(props.flight.id));

    return {
      price,
      duration,
      direction,
      numberOfStops,
      stopNames,
      airline,
      dates,
      details,
      flightImg,
      bookingUrl,
      redirectToActivity,
      bookActivity,
      booked,
    };
  },
});

export default AmxStaticFlightDetailsCard;
